import { useCallback, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

export function useRequireAuth() {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(() => {
        if (user) return true;
        navigate('/login', { state: { from: location.pathname } });
        return false;
    }, [user, navigate, location.pathname]);
}
